import './imageblock.less'

import {classes, Component, Image} from '@codeurs/front'
import m from 'mithril'
import {ImageType, LinkType} from 'types/types'
import ImageLink from '../imagelink'

export type ImageBlockType = {
	image: ImageType
	mod?: string
	image_link?: LinkType
}

export default class ImageBlock extends Component<ImageBlockType> {
	view() {
		const {image, mod, image_link} = this.attrs
		if (!image) return null

		return m('.imageblock',
			{...classes({mod})},
			m(ImageLink,
				{image_link},
				m(Image, {...classes({mod}), src: image.src, alt: image.alt || ''})
			)
		)
	}
}
